// 'unreachable' — הבקשה לא הגיעה או שהשרת לא ענה (502/503/504, למשל באמצע עדכון).
// 'reconnected' — השרת חזר; מסך שנכשל יכול לנסות שוב לבד (19/10/2026).
type ApiEvent = 'unauthenticated' | 'unreachable' | 'reconnected';
type Listener = () => void;

class ApiEvents {
  private listeners = new Map<ApiEvent, Set<Listener>>();

  on(ev: ApiEvent, fn: Listener): () => void {
    let bucket = this.listeners.get(ev);
    if (!bucket) {
      bucket = new Set();
      this.listeners.set(ev, bucket);
    }
    bucket.add(fn);
    return () => bucket.delete(fn);
  }

  emit(ev: ApiEvent): void {
    this.listeners.get(ev)?.forEach((fn) => fn());
  }
}

export const apiEvents = new ApiEvents();
